import { ReactNode } from "react";

import { ErrorBoundary } from "components/errorBoundary";

import { Body } from "../body";
import { useNewMenu } from "../navigation/useNewMenu";

import { SettingsLayout, SettingsSection } from "./SettingsLayout";

interface SettingsBodyProps {
    section: SettingsSection;
    title: string;
    routeKey: string;
    children: ReactNode;
}

/**
 * `Body` for a Settings page that draws no header of its own. A page that
 * does would get a second one.
 */
export function SettingsBody({
    section,
    title,
    routeKey,
    children,
}: SettingsBodyProps) {
    const newMenu = useNewMenu();
    const page = <ErrorBoundary routeKey={routeKey}>{children}</ErrorBoundary>;

    return (
        <Body
            navId="settings"
            title={title}
            routerLinks
            defaultAppBar={!newMenu}
        >
            {newMenu ? (
                <SettingsLayout section={section}>{page}</SettingsLayout>
            ) : (
                page
            )}
        </Body>
    );
}
